// experience data — compact, no skill lists

export const Experience = [
  {
    id: 1,
    company: "IDX Solana",
    role: "Full Stack Blockchain Developer",
    period: "Apr 2025 – Present",
    location: "New Delhi, India",
    points: [
      "Engineered a production-ready Web3 wallet browser extension (swap, send/receive, buy) with AES-256 + IV encryption and multi-layer security architecture, significantly strengthening asset protection.",
      "Developed and optimized idxsolana.io using Next.js & Tailwind CSS, improving performance, SEO, and increasing user engagement by 30%.",
      "Built Solana-based dApps with seamless wallet integration, on-chain transaction handling, and real-time blockchain data processing.",
      "Designed a secure admin dashboard with authentication, RBAC, and live monitoring, enhancing operational efficiency by 35%.",
      "Implemented analytics and monitoring pipelines, reducing issue detection and response time by 25%.",
    ],
  },
  {
    id: 2,
    company: "Ametheus Holdings Pvt. Ltd",
    role: "MERN Stack Developer",
    period: "Apr 2024 – Apr 2025",
    location: "New Delhi, India",
    points: [
      "Enhanced and scaled Assetorix (assetorix.com) by resolving critical issues and implementing new feature modules.",
      "Delivered 6+ production projects within an Agile team of 6 developers.",
      "Optimized ametheushealth.com with improved performance, SEO, API integrations, authentication, and payment gateway — achieving 30% higher engagement and 70% faster load times.",
    ],
  },
  {
    id: 3,
    company: "Molequle",
    role: "Frontend Developer",
    period: "Aug 2023 – Nov 2023",
    location: "Gurugram, India",
    points: [
      "Developed and deployed responsive web interfaces (HTML, CSS, React) for molequle.biz, improving user navigation efficiency by 25%.",
    ],
  },
];

// work data — featured projects first, then rest

export const Work = [
  {
    id: 8,
    name: "IDX Technologies",
    description: "Layer 3 AI Web3 infrastructure. Full-spectrum Web3 infrastructure stack for enterprises and developers — autonomous smart contracts, cross-chain compatibility, AI-enhanced cybersecurity, and decentralized computing.",
    tags: ["Web3", "Solana", "Blockchain", "AI"],
    demo: "https://www.idxsolana.io/",
    github: null
  },
  {
    id: 9,
    name: "IDX AutoBot",
    description: "AI-powered Web3 engines for automated trading on the Solana network — Volume Bot, Holders Maker, Token Burn, Bulk Sender, and more. Create, manage, and optimize with advanced AI algorithms.",
    tags: ["Solana", "Web3", "Trading", "AI"],
    demo: "https://tools.idxsolana.io/",
    github: null
  },
  {
    id: 10,
    name: "IDX Wallet",
    description: "A secure, multi-chain browser extension wallet. Send, swap, and stake Solana (SOL) and SPL tokens with transparent fees, non-custodial control, and seamless dApp interaction.",
    tags: ["Web3", "Solana", "Wallet", "Chrome Extension"],
    demo: "https://chromewebstore.google.com/detail/idx-wallet/gincibbmcbgnadapcecbadihomhdhogp",
    github: null
  },
  {
    id: 11,
    name: "Doctor Consultation",
    description: "MERN stack doctor consultation platform. Hospital onboarding, appointments, patient management, and multi-step forms for clinics and healthcare providers.",
    tags: ["React", "Node.js", "MongoDB", "MERN"],
    demo: "https://doctor-consultation.vercel.app/",
    github: "https://github.com/gourav-mishra551/doctor-consultation"
  },
  {
    id: 1,
    name: "Coffee cafe landing page",
    description: "This Website is my first project in html , css , javascript. It is a Landing page for a coffee cafe.",
    tags: ["html", "css", "javascript"],

    demo: "https://gourav-mishra551.github.io/coffee-website/",
    github: "https://github.com/gourav-mishra551"
  },
  {
    id: 2,
    name: "Gym Landing Page",
    description: "This website is a Landing page for a Gym. It is a responsive website built using HTML, CSS and javascript",
    tags: ["HTML", "CSS", "Javascript"],

    demo: "https://gourav-mishra551.github.io/GYM/",
    github: "https://github.com/gourav-mishra551"

  },
  {
    id: 3,
    name: "MOVIE-X-CLONE",
    description: "THIS WEBSITE IS INSPIRED FROM MOVIEX WEBSITE THIS WEBSITE IS MADE WITH MOVIE-X WEBSITE API TO LOAD DATA THE TECH STACK MAINLY USED ARE SCSS AND REACT",
    tags: ["react", "api", "sass"],

    demo: "https://movie-x-clone.vercel.app",
    github: "https://github.com/gourav-mishra551"
  },
  {
    id: 4,
    name: "3D-TSHIRT",
    description: "This website is made with react-three-fiber and OpenAi I made this Website with the help of youtube. In which i learn how to connect api and use it . I also learned how to use 3D models of blender in our websites.",
    tags: ["react", "styledComponents", "react-router ,'react-three-fiber"],

    demo: "https://github.com/gourav-mishra551/3D_Tshirt",
    github: "https://github.com/gourav-mishra551"

  }, {
    id: 5,
    name: "E-Commerce",
    description: "This website is a E-commerce website made with react and redux. This website is made with beautiful UI and UX .",
    tags: ["react", "redux", "CSS", "scss"],

    demo: "https://github.com/gourav-mishra551/E-Commerce",
    github: "https://github.com/gourav-mishra551"

  },
  {
    id: 6,
    name: "Haunted House",
    description: "A website where you can see a 3d haunted house made with three.js.",
    tags: ["react", "Three.js", "css"],

    demo: "https://github.com/gourav-mishra551/Haunted_House_new",
    github: "https://github.com/gourav-mishra551"

  },
  {
    id: 7,
    name: "More Projects",
    description: "My Github Profile",
    tags: ["react", "Three.js", "css"],
    demo: "https://github.com/gourav-mishra551/",
    github: "https://github.com/gourav-mishra551/"
  }
] 